import 'cally';
import '@justinribeiro/lite-youtube';
import '@dweidner/ajax-fragment-element';

import { DatePicker } from './DatePicker/DatePicker.js';
import { FloatingPopover } from './FloatingPopover/FloatingPopover.js';
import { FocusZone } from './FocusZone/FocusZone.js';
import { ResponsiveNav } from './ResponsiveNav/ResponsiveNav.js';
import { ToggleButton } from './ToggleButton/ToggleButton.js';

export default {
  /**
   * @param {object} _app
   */
  install(_app) {
    customElements.define('date-picker', DatePicker);
    customElements.define('floating-popover', FloatingPopover);
    customElements.define('focus-zone', FocusZone);
    customElements.define('responsive-nav', ResponsiveNav);
    customElements.define('toggle-button', ToggleButton);
  }
}